<template>
    <b-container class="border" fluid>
        <draggable v-model="availableColumns" @start="isDragging=true" @end="isDragging=false">
            <b-row class="border">
                <b-col>
                    {{$t('device_list.settings.column')}}
                </b-col>
                <b-col>
                    {{$t('device_list.settings.visibility')}}
                </b-col>
            </b-row>
            <b-row v-for="field in availableColumns" :key="field.key" class="border">
                <b-col style="{width: 50px}">
                    {{$t(field.label_t)}}
                </b-col>
                <b-col>
                    <b-checkbox v-model="field.visible">
                    </b-checkbox>
                </b-col>
            </b-row>
        </draggable>
    </b-container>
</template>

<script>
    import draggable from 'vuedraggable'

    export default {
        name: "DeviceListTableSettings",
        components: {
            draggable,
        },
        data() {
            return {
                isDragging: false,
            }
        },
        computed: {
            availableColumns: {
                get() {
                    return this.$store.state.deviceListTableFields
                },
                set(value) {
                    this.$store.commit('updateDeviceListTableFields', value)
                }
            }
        }
    }
</script>

<style scoped>
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }
</style>